var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectPhoneMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 13V43H37.375V13H18.625ZM35.5 19.5625V36.4375H20.5V14.875H35.5V19.5625ZM20.5 41.125V38.3125H26.125V40.1875H29.875V38.3125H35.5V41.125H20.5Z",
    fill: "#0089EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectPhoneMinor);
export default __webpack_public_path__ + "static/media/object-phone-minor.1b84f88136e7e2e36482d6c87809841a.svg";
export { ForwardRef as ReactComponent };